import { createWatch } from 'effector'
import { debug as _debug } from 'patronum/debug'
import {
  branch,
  dockerImage,
  eraBranch,
  eraDockerImage,
} from '~/app/environment/versions'
import { $wbsRawVersion } from '~/core/flags/versioning'
import { noop } from '~/shared/helpers'

// print versions to console on startup
const console = globalThis.__console || globalThis.console
console.log(
  `%ctria - %csetplexapps/tria:%c${dockerImage} %c${branch ? `(${branch})` : ''}\r\n%cera - %csetplexapps/era:%c${eraDockerImage} %c${eraBranch ? `(${eraBranch})` : ''}`,
  'border-left:2px solid red;padding-left:5px',
  'color:gray',
  'color:inherit',
  'color:pink',
  'color:inherit;border-left:2px solid red;padding-left:5px',
  'color:gray',
  'color:inherit',
  'color:pink'
)

// print wbs version once, when it will be available
const unwatch = createWatch({
  unit: $wbsRawVersion,
  fn(version) {
    if (version) {
      console.log(
        `%cwbs - ${version.replace('#', '-')}`,
        'border-left:2px solid green;padding-left:5px'
      )
      unwatch()
    }
  },
})

if (__NODE_ENV__ === 'production') {
  window.debug = noop
} else {
  globalThis.debug = _debug
  globalThis.debugUseEvents = false
  globalThis.debugUseData = false
  globalThis.debugUseRaw = false
  globalThis.debugExact = false
}

// add mimic in development mode
if (__NODE_ENV__ !== 'production') {
  if (/^1|yes|true$/i.test(import.meta.env.VITE_MIMIC)) {
    import('mimic')
  }
}
